<template>
  <div>
    <storm-ui-form-group
      border
      :gap-y="1"
    >
      <div class="col-span-13">
        <storm-ui-input
          name="street"
          placeholder="Anschrift"
          label="Anschrift"
        />
      </div>
      <div class="col-span-9" />
      <div class="col-span-2" />

      <div class="col-span-3">
        <storm-ui-input
          placeholder="PLZ"
          name="zip"
        />
      </div>
      <div class="col-span-10">
        <storm-ui-input
          placeholder="Ort"
          name="city"
        />
      </div>
      <div class="col-span-9" />
      <div class="col-span-13">
        <storm-ui-select
          name="country_id"
          placeholder="Land"
          :options="params.countries"
          empty
        />
      </div>
    </storm-ui-form-group>
    <storm-ui-form-group border>
      <div class="col-span-5">
        <storm-ui-date-picker
          id="dob"
          name="dot"
          label="Geburtstag"
          type="text"
        />
      </div>
    </storm-ui-form-group>
    <storm-ui-form-group border>
      <div class="col-span-24">
        <storm-ui-input
          name="note"
          type="textarea"
          label="Notiz"
          :rows="3"
        />
      </div>
    </storm-ui-form-group>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/pinia/GlobalStore'
const globalStore = useGlobalStore()
const { params } = storeToRefs(globalStore)
</script>
